import React from 'react'
import {Box} from '@chakra-ui/react'
import Footer from '../components/Common/Footer'
import Newsletter from '../components/Common/Newsletter'
import Navbar from '../components/Navbar'
import Feature from '../components/Product/Feature'
import Header from '../components/QrCode/Header'
import HowItWorks from '../components/Product/HowItWorks'

const Qr = () => {
  return (
    <div>
        <Navbar/>
        <Header/>
        <Box display={['none','block']}>
          <Feature/>
        </Box>
        <HowItWorks/>
        <Newsletter/>
        <Footer/>
    </div>
  )
}

export default Qr